require("@rails/ujs").start()
require("@rails/activestorage").start()
require("chartkick")
require("chart.js")
require("custom/mouseTrap")